import { render, staticRenderFns } from "./SaveToLibraryPanel.vue?vue&type=template&id=f520e4de"
import script from "./SaveToLibraryPanel.vue?vue&type=script&lang=js"
export * from "./SaveToLibraryPanel.vue?vue&type=script&lang=js"
import style0 from "./SaveToLibraryPanel.vue?vue&type=style&index=0&id=f520e4de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports